import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerBankAll: [],
  insurerBank: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerBankSlice = createSlice({
  name: "insurerBank",
  initialState,
  reducers: {
    setInsurerBankAll: (state, action) => {
      state.insurerBankAll = action.payload;
    },
    setInsurerBank: (state, action) => {
      state.insurerBank = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerBankAll,
  setInsurerBank,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerBankSlice.actions;

export default insurerBankSlice.reducer;
